import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
                  <i className="ri-movie-2-line text-foreground-50 text-xl"></i>
                </div>
                <span className="text-lg font-bold text-foreground-100 font-heading">8090影院</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                8090影院网聚合免费电影大全资源，高清电影在线观看国内外大片，打造不缓冲影院体验，电影无广告干扰，海量影片随心点播。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-5 font-heading">电影分类</h4>
              <div className="grid grid-cols-2 gap-2">
                {categories.slice(0, 8).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors py-1"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-5 font-heading">快速链接</h4>
              <div className="space-y-2.5">
                <Link to="/" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                  首页
                </Link>
                <Link to="/about" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                  关于我们
                </Link>
                <Link to="/category/all" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                  全部电影
                </Link>
                <Link to="/category/kehuan" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                  科幻电影
                </Link>
                <Link to="/category/dongzuo" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                  动作电影
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-5 font-heading">联系我们</h4>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-mail-line text-foreground-500 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-500">contact@8090cinema.com</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-customer-service-2-line text-foreground-500 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-500">在线客服：工作日 9:00-18:00</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; 2026 8090影院 版权所有 | 本站所有内容均来自互联网，仅供交流学习使用
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}